import api from 'app/utils/api';

export class DocusealService {
  public static getBuilderToken({ documentType = '', templateId = '' }) {
    return api.get('/integrations/docuseal/builder-token', {
      params: { documentType, templateId },
    });
  }

  public static getRequestSignatureToken(documentIdsString: string) {
    return api.get('/integrations/docuseal/request-signature-token', {
      params: { documentIds: documentIdsString },
    });
  }

  public static sendSignatureRequest(data: object) {
    return api.post('/integrations/docuseal/signature-request', data);
  }

  public static deleteSignatureRequest(signatureRequestId: string) {
    return api.delete(
      `/integrations/docuseal/signature-request/${signatureRequestId}`
    );
  }

  public static getSignatureTemplate(templateId: string) {
    return api.get(`/integrations/docuseal/template/${templateId}`);
  }

  public static getSignatureTemplates() {
    return api.get('/integrations/docuseal/templates');
  }

  public static updateSavedTemplate(data: object) {
    const requestBody = {
      templateData: data,
    };
    return api.post('/integrations/docuseal/template', requestBody);
  }

  public static deleteSignatureTemplate(templateId: string) {
    return api.delete(`/integrations/docuseal/template/${templateId}`);
  }
}
